import { render, staticRenderFns } from "./ReportNotes.vue?vue&type=template&id=23091558&scoped=true"
import script from "./ReportNotes.vue?vue&type=script&lang=js"
export * from "./ReportNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23091558",
  null
  
)

export default component.exports